import { useQmsSubmitExamPaperMutation } from '../../generated/graphql';

export default useQmsSubmitExamPaperMutation;
